import { Modal, Result, Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { transactionApproveApi } from '@http/transactions';
import { salaryActionModalOpenAC } from '@store/reducers/salary';

const SalaryActionModal = (props: any) => {
  const { fileId } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isSalaryActionModalOpen = useAppSelector(state => state.salaryReducer.isSalaryActionModalOpen);
  const actionModalType = useAppSelector(state => state.salaryReducer.actionModalType);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const approveFile = async (action: 'APPROVE' | 'DECLINE') => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      await dispatch(
        transactionApproveApi(
          {
            params: {
              trans_id: fileId,
              action,
              trn_type: 'SALARY',
            },
            fileId: fileId,
          },
          () => dispatch(salaryActionModalOpenAC(false))
        )
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Modal
        open={isSalaryActionModalOpen}
        onOk={() => dispatch(salaryActionModalOpenAC(false))}
        onCancel={() => dispatch(salaryActionModalOpenAC(false))}
        footer={null}
        width={400}
      >
        <Result
          status='warning'
          title={actionModalType === 'DECLINE' ? t('Sure to decline?') : t('Sure to confirm?')}
          extra={[
            <div key='salary-action'>
              {actionModalType === 'DECLINE' ? (
                <Button
                  type='primary'
                  danger
                  size='middle'
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  onClick={() => approveFile('DECLINE')}
                >
                  {t('Reject')}
                </Button>
              ) : (
                <Button
                  type='primary'
                  size='middle'
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  onClick={() => approveFile('APPROVE')}
                >
                  {t('Confirm')}
                </Button>
              )}
            </div>,
          ]}
        />
      </Modal>
    </div>
  );
};

export default SalaryActionModal;
